import React from "react";
import { Box } from "@mui/material";

const StatusCardWrapper = ({ children }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row", // Arrange items in a single row
        alignItems: "center", // Align items vertically
        overflowX: "auto", // Enable horizontal scrolling
        gap: 2, // Add spacing between cards
        p: 2, // Add padding inside the container
        width: "100%", // Take full width of the parent
        boxSizing: "border-box", // Include padding/border in the size calculation

        // Invisible scrollbar
        "&::-webkit-scrollbar": {
          display: "none", // Hide scrollbar for WebKit-based browsers
        },
        scrollbarWidth: "none", // Hide scrollbar for Firefox
      }}
    >
      {children}
    </Box>
  );
};

export default StatusCardWrapper;
